import { render, staticRenderFns } from "./set-staff-room-modal.vue?vue&type=template&id=bf4355e0&scoped=true"
import script from "./set-staff-room-modal.vue?vue&type=script&lang=js"
export * from "./set-staff-room-modal.vue?vue&type=script&lang=js"
import style0 from "./set-staff-room-modal.vue?vue&type=style&index=0&id=bf4355e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4355e0",
  null
  
)

export default component.exports